import { atom } from 'jotai';
import { type ReactNode } from 'react';

export const canCollapseAtom = atom(true);
export const mobileHeaderActionsAtom = atom<ReactNode>(null);

/** Mounted page headers that replace the default mobile chrome. */
export const mobilePageHeaderOwnersAtom = atom(0);
export const mobileChatHistoryOpenAtom = atom(false);
